import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Link, useParams, useLocation  } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { useSelector, useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { Footer, Navbar, Reviews } from "../components";
import axios from "axios";
import configData from "../config.json";
import "../styles/product.css"; 

const Product = () => {
  const { productId, categoryId } = useParams();
  // const location = useLocation();
  // const { productId, categoryId } = location.state || {};

  const cart = useSelector((state) => state.handleCart);
  const dispatch = useDispatch();

  const [product, setProduct] = useState(null);
  const [similarProducts, setSimilarProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSimilar, setLoadingSimilar] = useState(true);
  const [error, setError] = useState("");

  // 🔹 Fetch Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const productRes = await axios.get(`${configData.SERVER_URL}/products/${productId}`);
        setProduct(productRes.data?.[0] || productRes.data);

        setLoading(false);

        const similarRes = await axios.get(`${configData.SERVER_URL}/products/category/${categoryId}`);
        setSimilarProducts(similarRes.data);

      } catch (err) {
        console.error(err);
        setError("Failed to load product");
      } finally {
        setLoading(false);
        setLoadingSimilar(false);
      }
    };

    fetchData();
  }, [productId, categoryId]);

  // 🔹 Add to Cart (fixed)
  const handleAddCart = (product) => {
    if (cart.length > 0) {
      const sameBranch = cart.every(
        (item) => item.BranchId === product.BranchId
      );

      if (!sameBranch) {
        alert("Multiple branch products not allowed in one cart");
        return;
      }
    }

    dispatch(addCart(product));
  };

  // 🔹 Loading UI
  const LoadingView = () => (
    <div className="row py-5">
      <div className="col-md-6 text-center">
        <Skeleton height={350} />
      </div>
      <div className="col-md-6">
        <Skeleton height={30} width={200} />
        <Skeleton height={50} />
        <Skeleton height={30} width={100} />
        <Skeleton height={100} />
        <Skeleton height={40} width={120} />
      </div>
    </div>
  );

  // 🔹 Product UI
  const ProductView = () => (
    <div className="row py-5 align-items-center">

      {/* Image */}
      <div className="col-md-6 text-center">
        <img
          src={`${configData.IMAGE_URL}/products/${product.Image}`}
          alt={product.ProductName}
          className="img-fluid rounded shadow-sm"
          style={{ maxHeight: "400px", objectFit: "contain" }}
        />
      </div>

      {/* Details */}
      <div className="col-md-6">

        <h6 className="text-muted">{product.subCategory}</h6>

        <h2 className="fw-bold text-success">
          {product.ProductName}
        </h2>

        <h4 className="my-3 text-dark">
          ৳ {product.ProductPrice.toLocaleString()} / {product.munit}
        </h4>

        {/* Description */}
        <ul className="text-muted">
          {product.Description?.split(";").map((d, i) => (
            <li key={i}>{d}</li>
          ))}
        </ul>

        {/* Contact */}
        <p className="text-danger fw-semibold">
          📞 {product.hotlineNo}
        </p>

        {/* Actions */}
        <div className="mt-3">
          {product.UnitsInStock === 0 ? (
            <button className="btn btn-danger me-2" disabled>
              Out of Stock
            </button>
          ) : (
            <button
              className="btn btn-success me-2"
              onClick={() => handleAddCart(product)}
            >
              Add to Cart
            </button>
          )}

          <Link to="/cart" className="btn btn-outline-dark">
            Go to Cart
          </Link>
        </div>
      </div>
    </div>
  );

  // 🔹 Similar Products
  const SimilarProductsView = () => (
    <Marquee pauseOnHover speed={60}>
      {similarProducts.map((item) => (
        <div
          key={item.ProductID}
          className="card mx-3 product-card border-0 shadow-sm"
          style={{ width: "220px" }}
        >
          <img
            src={`${configData.IMAGE_URL}/products/${item.Image}`}
            alt={item.ProductName}
            className="p-3"
            style={{ height: "150px", objectFit: "contain" }}
          />

          <div className="card-body text-center">
            <small className="fw-semibold">
              {item.ProductName}
            </small>
          </div>

          <div className="card-footer bg-white border-0 text-center">
            <Link
              to={`/product/${item.ProductID}/${item.CategoryID}`}
              // to={"/productDetails"}
              // state={{ 
              //   productId: item.ProductID, 
              //   categoryId: item.CategoryID 
              // }}
              className="btn btn-sm btn-outline-dark me-1"
            >
              View
            </Link>

            {item.UnitsInStock === 0 ? (
              <button className="btn btn-sm btn-danger" disabled>
                Out
              </button>
            ) : (
              <button
                className="btn btn-sm btn-success"
                onClick={() => handleAddCart(item)}
              >
                Add
              </button>
            )}
          </div>
        </div>
      ))}
    </Marquee>
  );

  return (
    <>
      <Navbar />

      <div className="container">

        {/* Error */}
        {error && <p className="text-danger text-center">{error}</p>}

        {/* Product */}
        {loading ? <LoadingView /> : product && <ProductView />}

        {/* Reviews */}
        <div className="col-lg-6"><Reviews productId={productId}/></div>
        

        {/* Similar */}
        <div className="my-5">
          <h4 className="text-success mb-3">You may also like</h4>
          {loadingSimilar ? <Skeleton height={200} /> : <SimilarProductsView />}
        </div>

      </div>

      <Footer />
    </>
  );
};

export default Product;